package it.neckar.lizergy.model.stumps

import it.neckar.lizergy.model.configuration.quote.builder.InverterConfiguration.InverterConfigurationId
import it.neckar.lizergy.model.configuration.quote.builder.InverterConfiguration.StringConfiguration.StringConfigurationId
import it.neckar.lizergy.model.energy.Current
import it.neckar.lizergy.model.energy.Resistance
import it.neckar.lizergy.model.energy.Voltage
import it.neckar.lizergy.model.project.ProjectConfiguration.PhotovoltaicsProjectId
import it.neckar.open.kotlin.serializers.IsoMillis
import it.neckar.open.unit.si.MOhms
import it.neckar.open.unit.si.Ohms
import it.neckar.uuid.HasUuid
import it.neckar.uuid.NativeUuid
import kotlinx.serialization.Serializable
import kotlin.uuid.Uuid

@Serializable
data class AssemblyRoof(
  override val uuid: NativeUuid,
  val projectId: PhotovoltaicsProjectId,
  val inverterMessdaten: List<InverterMessdaten> = emptyList(),
) : HasUuid {

  @Serializable
  data class InverterMessdaten(
    override val inverterConfigurationId: InverterConfigurationId? = null,
    val inverterSerialNumber: String? = null,
    val stringMessdaten: List<StringMessdaten> = emptyList(),
    val wetterbedingungen: String? = null,
    val uhrzeit: IsoMillis? = null,
    val monteur: String? = null,
    val bemerkungen: String = "",
  ) : InverterMessdatenEntry {
    operator fun get(stringConfigurationId: StringConfigurationId): StringMessdaten? {
      return stringMessdaten.firstOrNull { it.stringConfigurationId == stringConfigurationId }
    }
  }

  @Serializable
  data class StringMessdaten(
    val stringConfigurationId: StringConfigurationId,
    val stringBezeichnung: String?,
    val anzahlOptimierer: Int?,
    val stringSpannungDachmontage: Voltage?,
    val stringSpannungInbetriebnahme: Voltage?,
    val stringLeerlaufspannung: Voltage?,
    val stringKurzschlussstrom: Current?,
    val isolationsWiderstand: @MOhms Resistance?,
    val rpe: @Ohms Resistance?,
  ) : HasUuid {
    override val uuid: Uuid
      get() = stringConfigurationId.uuid

    companion object {
      fun getEmpty(stringConfigurationId: StringConfigurationId): StringMessdaten {
        return StringMessdaten(
          stringConfigurationId = stringConfigurationId,
          stringBezeichnung = null,
          anzahlOptimierer = null,
          stringSpannungDachmontage = null,
          stringSpannungInbetriebnahme = null,
          stringLeerlaufspannung = null,
          stringKurzschlussstrom = null,
          isolationsWiderstand = null,
          rpe = null
        )
      }
    }
  }

}
